module.exports = __webpack_public_path__ + "static/media/elcano_5.12a54213.png";